import { ethers } from "ethers";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import ReceivePayments from "./receivePaymentsAbi.json";
import ObscuraMintPass2 from "contracts/ObscuraMintPass2.json";
import ObscuraMintPass3 from 'contracts/ObscuraMintPass3.json';
import { toast } from 'react-toast';
import { TX_STATE } from '@components/TxLoader';
import { COMMISSIONS } from 'logic/commissions';

const WEB3_MODAL_CONFIG = {
  network: process.env.NEXT_PUBLIC_NETWORK,
  cacheProvider: true,
  providerOptions: {
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        infuraId: process.env.NEXT_PUBLIC_INFURA_ID,
      },
    },
  },
};

export const PurchaseObscuraMintPass3 = async (
  commissionTier: COMMISSIONS,
  setTxState
) => {
  const web3Modal = new Web3Modal(WEB3_MODAL_CONFIG);
  const connection = await web3Modal.connect();
  const provider = new ethers.providers.Web3Provider(connection);
  console.log(WEB3_MODAL_CONFIG);
  const signer = provider.getSigner();
  const OBSCURA_MINT_PASS_3_ADDRESS =
    process.env.NEXT_PUBLIC_OBSCURA_MINT_PASS_3_CONTRACT;

  let minterContract;
  try {
    minterContract = await new ethers.Contract(
      OBSCURA_MINT_PASS_3_ADDRESS,
      ObscuraMintPass3.abi,
      signer
    );
  } catch (error) {
    console.error('Failed to get contracts', error);
    handleError(error);
  }

  const correctNetwork = await checkNetwork(provider);
  if (!correctNetwork) return;

  // const saleActive = await minterContract
  //   .isSalePublic(passId)
  //   .catch((e) => console.error(e));

  // if (saleActive == false) {
  //   toast.error('Sale not active');
  //   return;
  // }

  const passConfig = {
    [COMMISSIONS.curated]: {
      price: 3,
      passId: 3,
    },
    [COMMISSIONS.magnum]: {
      price: 3,
      passId: 4,
    },
  };
  const { price, passId } = passConfig[commissionTier];
  if (!price || !passId) {
    toast.success('Invalid Pass');
  }
  const payingAmount = ethers.utils.parseEther(price.toString());
  try {
    const gasLimit = await minterContract.estimateGas.buyPass(passId, {
      value: payingAmount,
    });
    setTxState({ state: TX_STATE.APPROVE });

    if (gasLimit) {
      const tx = await minterContract.buyPass(passId, {
        value: payingAmount,
        gasLimit: 100000 + Number(gasLimit),
      });

      const receipt = await tx.wait();
      console.log('txReceipt: ', receipt);
      if (receipt && receipt.status === 1) {
        toast.success('Successfully Purchased Mint Pass');
        setTxState({ state: null, txHash: null });
      } else {
        toast.error('Transaction Failed');
        setTxState({ state: null, txHash: null });
      }
    }
  } catch (e) {
    handleError(e);
  }
  setTxState({ state: null });
};

export const PurchaseObscuraMintPass2 = async (passId, setTxState) => {
  const web3Modal = new Web3Modal(WEB3_MODAL_CONFIG);
  const connection = await web3Modal.connect();
  const provider = new ethers.providers.Web3Provider(connection);
  const signer = provider.getSigner();
  const OBSCURA_MINT_PASS_2_ADDRESS =
    process.env.NEXT_PUBLIC_OBSCURA_MINT_PASS_2_CONTRACT;
  const OBSCURA_MINT_PASS_2_ABI = ObscuraMintPass2.abi;

  let minterContract;
  try {
    minterContract = await new ethers.Contract(
      OBSCURA_MINT_PASS_2_ADDRESS,
      OBSCURA_MINT_PASS_2_ABI,
      signer
    );
  } catch (error) {
    console.error('Failed to get contracts', error);
    handleError(error);
  }

  const correctNetwork = await checkNetwork(provider);
  if (!correctNetwork) return;

  const saleActive = await minterContract
    .isSalePublic(passId)
    .catch((e) => console.error(e));

  if (saleActive == false) {
    toast.error('Sale not active');
    return;
  }

  const passPrice = await minterContract.getPassPrice(passId);

  const parsedPassPrice = ethers.utils.formatEther(passPrice.toString());
  const payingAmount = ethers.utils.parseEther(parsedPassPrice);
  console.log(passPrice, parsedPassPrice);
  const gasLimit = await minterContract.estimateGas
    .buy(passId, { value: payingAmount })
    .catch(handleError);
  if (gasLimit) {
    setTxState({ state: TX_STATE.APPROVE });
    await minterContract
      .buy(passId, { value: payingAmount, gasLimit: 100000 + Number(gasLimit) })
      .then((tx) => {
        setTxState({ state: TX_STATE.IN_PROGRESS, txHash: tx.hash });

        return tx.wait().then((receipt) => {
          console.log('txReceipt: ', receipt);
          if (receipt && receipt.status === 1) {
            toast.success('Successfully Purchased Mint Pass');
            setTxState({ state: null, txHash: null });
          } else {
            toast.error('Transaction Failed');
            setTxState({ state: null, txHash: null });
          }
        });
      })
      .catch(handleError);
  }
  setTxState({ state: null });
};

const checkNetwork = async (provider) => {
  const { chainId } = await provider.getNetwork();

  if (chainId) {
    if (process.env.NEXT_PUBLIC_NETWORK == 'rinkeby' && chainId != 4) {
      toast.error('Please switch to rinkeby');
      return false;
    } else if (process.env.NEXT_PUBLIC_NETWORK == 'mainnet' && chainId != 1) {
      toast.error('Please switch to mainnet');
      return false;
    }
  }

  return true;
};


export const PurchaseSeasonPass = (params) => {
  const { pass: passType, numberOfPasses: numberOfPasses } = params;
  async function startPayment() {
    // todos
    // priority.
    // tell user there are insufficient funds.
    // check that there's wallet installed
    // check that on correct network.

    const web3Modal = new Web3Modal(WEB3_MODAL_CONFIG);
    // NOTE: HARDCODED PASSES

    try {
      const passConfig = {
        curatedsp1: { id: 0, price: 2.8 },
        foundrysp1: { id: 1, price: 1.4 },
        communitysp1: { id: 2, price: 1.4 },
        foundrysp1gen: { id: 3, price: 1.75 },
        communitysp1gen: { id: 4, price: 1.75 },
      };

      const connection = await web3Modal.connect();
      const provider = new ethers.providers.Web3Provider(connection);
      const signer = provider.getSigner();
      const receivePaymentsAddress =
        process.env.NEXT_PUBLIC_RECEIVE_PAYMENTS_CONTRACT;

      const contract = new ethers.Contract(
        receivePaymentsAddress,
        ReceivePayments.abi,
        signer
      );

      const price = ethers.utils.parseEther(
        (passConfig[passType].price * numberOfPasses).toString()
      );
      const txn = await contract.receivePassPayment(
        passConfig[passType].id,
        numberOfPasses,
        { value: price }
      );

      await txn.wait().then((result) => {
        console.log(result);
        // see if any good info here
      });
    } catch (e) {
      console.error(e);
      handleError(e)
    }
  }
  startPayment();
};


const handleError = (e) => {
  if (e.error && e.error.message) {
    toast.error(e.error.message);
  } else if (e.message) {
    toast.error(e.message);
  } else if (e.reason) {
    toast.error(e.reason);
  }
};